import Modal from "@common/components/modal/Modal";
import { Text } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";

interface AddCampusesConfirmModalProps {
  isOpen?: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const AddCampusesConfirmModal = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
}: AddCampusesConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      typeState="confirm"
      show={isOpen}
      isLoading={isLoading}
      title={t("programming-structures.modals.add-campuses.title")}
      textButtonPrincipal={t("programming-structures.modals.add-campuses.save-publish")}
      textButtonSecondary={t("programming-structures.modals.add-campuses.keep-editing")}
      onClose={onClose}
      onClickPrincipal={onConfirm}
      onClickSecondary={onClose}
    >
      <Text>{t("programming-structures.modals.add-campuses.description")}</Text>
    </Modal>
  );
};

export default AddCampusesConfirmModal;
